import React from 'react';
import MarkdownViewer from './MarkdownViewer';

function RefundPolicy() {
  return (
    <MarkdownViewer
      title="Refund Policy"
      fileName="REFUND_POLICY.md"
    />
  );
}

export default RefundPolicy;
